import { useAtomValue } from 'jotai';
import {
  simProductsFiltersAtom,
  simProductsSortingAtomWithStorage,
} from 'atoms/filters/sim-products';
import { useExternalRowSelectionClearOnFiltersChange } from 'src/common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/hooks/useExternalRowSelectionClearOnFiltersChange';

export const SimProductsSelectionReset = () => {
  const filters = useAtomValue(simProductsFiltersAtom);
  const sorting = useAtomValue(simProductsSortingAtomWithStorage);

  useExternalRowSelectionClearOnFiltersChange({ filters, sorting });

  return null;
};
